<template>
    <ul class="list-unstyled mb-0">
        <li v-for="(address, i) in addresses" :class="i > 0 ? 'mt-2' : ''">
            <i class="fa fa-globe"></i>
            {{ address.address }} <br v-if="address.address && address.city" />
            <span class="d-block">{{ address.city }}, {{ address.state_id ? address.state.state_name : '' }} {{ address.zip }}</span>
            <label class="badge badge-info" style="font-size: 85%; font-weight: 400;" v-if="address.is_primary">Primary</label>
            <label v-for="type in address.address_types" class="badge badge-default">{{ type }}</label>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            addresses: {
                type: Array,
                required: true,
            }
        },

        data() {
            return {

            }
        },

        watch: {

        },

        computed: {

        },

        methods: {

        },

        mounted() {

        }
    }
</script>
